<po-modal
  (p-close)="onClose()"
  [p-click-out]="false"
  [p-hide-close]="modalHideClose"
  [p-title]="title"
  [p-primary-action]="modalPrimaryAction"
  [p-secondary-action]="modalSecondaryAction"
>
  <div *ngIf="!addingProject">
    <form #projectForm="ngForm">
      <div class="po-row">
        <po-select
          class="po-lg-6"
          p-required
          name="platform"
          p-label="Plataforma"
          p-placeholder="Selecione a plataforma"
          [(ngModel)]="platform"
          [p-options]="platformOptions"
          [p-readonly]="platformIsReadOnly"
          [p-disabled]="platformIsDisabled"
          (p-change)="onPlatformChange($event)"
        />

        <po-combo
          *ngIf="!projectIsReadOnly && showProjectCombo"
          class="po-lg-6"
          name="name"
          p-clean
          [(ngModel)]="name"
          p-label="Projeto"
          p-placeholder="Selecione o projeto"
          p-filter-mode="contains"
          p-required
          p-sort
          [p-options]="projectOptions"
          [p-disabled]="projectIsDisabled"
          (p-change)="onProjectSearchChange($event)"
        >
          <ng-template p-combo-option-template let-option>
            <ng-container
              *ngIf="
                option.options;
                then projectOptionsGroupTitle;
                else projectOptionsGroup
              "
            />

            <ng-template #projectOptionsGroupTitle>
              <div class="po-row">
                <p class="po-sm-10 po-md-9 po-lg-11">{{ option.label }}</p>
              </div>
            </ng-template>

            <ng-template #projectOptionsGroup>
              <div class="po-sm-10 po-md-9 po-lg-11 po-pt-1 po-pb-1">
                <div class="po-font-text-large-bold">
                  {{ option.label }}
                </div>

                <div *ngIf="option.description" class="po-font-text-small">
                  {{ option.description }}
                </div>
              </div>
            </ng-template>
          </ng-template>
        </po-combo>

        <po-input
          *ngIf="projectIsReadOnly || !showProjectCombo"
          class="po-lg-6"
          p-label="Projeto"
          [(ngModel)]="name"
          name="name"
          p-required
          p-placeholder="Digite o nome do projeto"
          [p-readonly]="projectIsReadOnly"
          [p-disabled]="projectIsDisabled"
        />
      </div>

      <div class="po-row">
        <po-url
          class="po-lg-6"
          p-icon=""
          p-label="Repositório"
          p-placeholder="Informe a URL do repositório do projeto"
          [(ngModel)]="repository"
          name="repository"
          [p-disabled]="repositoryIsDisabled"
          [p-readonly]="repositoryIsReadOnly"
          p-required
          (p-change)="onRepositoryChange($event)"
          p-error-pattern="A URL do repositório não é válida para a plataforma Azure DevOps."
          [p-help]="helpRepository"
        />

        <po-input
          class="po-lg-6"
          p-label="Branch padrão"
          [(ngModel)]="branch"
          name="branch"
          [p-disabled]="repositoryIsDisabled"
          [p-readonly]="branchIsReadOnly"
          p-placeholder="Digite o nome da branch padrão do projeto"
          p-required
          [p-help]="helpBranch"
        />
      </div>

      <div class="po-row">
        <po-combo
          class="po-lg-6"
          name="team"
          p-clean
          [(ngModel)]="team"
          p-label="Time"
          p-placeholder="Selecione o time que mantém o projeto"
          [p-options]="teamOptions"
          p-filter-mode="contains"
          p-required
          p-sort
        />

        <po-radio-group
          class="po-lg-6"
          p-label="O projeto está ativo?"
          [p-options]="rpoOptions"
          [(ngModel)]="status"
          name="status"
          p-required
        />
      </div>

      <div class="po-row">
        <po-radio-group
          class="po-lg-6"
          p-label="O projeto está publicado?"
          [p-options]="rpoOptions"
          [(ngModel)]="rpo"
          name="rpo"
          p-required
        />

        <po-email
          class="po-lg-6"
          p-icon=""
          p-label="Product Owner (PO)"
          p-placeholder="Digite o e-mail do Product Owner do projeto"
          [(ngModel)]="productOwner"
          name="productOwner"
          p-clean
          p-required
          p-help="Exemplo: po@totvs.com.br"
        />
      </div>
    </form>
  </div>

  <po-progress
    *ngIf="addingProject"
    [p-value]="progressValue"
    [p-indeterminate]="progressIndeterminate"
    [p-status]="progressStatus"
    [p-text]="progressText"
    [p-info]="progressInfo"
  />

  <div *ngIf="processError" class="po-p-0 po-m-0">
    <br />

    <po-widget p-title="Atenção!" [p-primary]="true">
      <p [innerHTML]="processError"></p>
    </po-widget>
  </div>
</po-modal>
